import { render, staticRenderFns } from "./BdoRadio.vue?vue&type=template&id=b76a1236&scoped=true"
import script from "./BdoRadio.vue?vue&type=script&lang=js"
export * from "./BdoRadio.vue?vue&type=script&lang=js"
import style0 from "./BdoRadio.vue?vue&type=style&index=0&id=b76a1236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76a1236",
  null
  
)

export default component.exports